import React from "react";
import "../../assets/css/Common/Pipeline.css";

/**
 * Reusable Pipeline Progress Component
 *
 * @param {Object} props
 * @param {Array<{stage: string, completed?: boolean, current?: boolean}>} props.steps - Pipeline steps/stages
 * @param {Array<{stage: string, completed?: boolean, current?: boolean}>} [props.pipeline] - Alias for steps
 * @param {string|boolean|null} [props.title="Pipeline Progress"] - Header title, false/null to hide
 * @param {string} [props.color="#22c55e"] - Accent color for active/completed indicators
 * @param {string} [props.className=""] - Additional class name for outer container
 */
export default function Pipeline({
  steps,
  pipeline,
  title = "Pipeline Progress",
  color = "#22c55e",
  className = "",
}) {
  const stageList = steps || pipeline;

  if (!Array.isArray(stageList) || stageList.length === 0) {
    return null;
  }

  return (
    <div
      className={`pipeline-section lead-pipeline-section ${className}`.trim()}
    >
      {title && <h4>{title}</h4>}

      <div className="pipeline-container deal-pipeline-container lead-pipeline-container">
        {stageList.map((step, index) => {
          const isLast = index === stageList.length - 1;

          return (
            <div
              key={step.stage || index}
              className={`pipeline-item deal-pipeline-item lead-pipeline-item ${
                step.current ? "current" : ""
              }`}
            >
              <div className="pipeline-node-track deal-pipeline-node-track lead-pipeline-node-track">
                <div
                  className={`pipeline-circle deal-pipeline-circle lead-pipeline-circle ${
                    step.completed ? "completed" : ""
                  } ${step.current ? "current" : ""}`}
                  style={{
                    "--pipeline-color": color,
                    "--deal-pipeline-color": color,
                    "--lead-pipeline-color": color,
                  }}
                >
                  {index + 1}
                </div>

                {!isLast && (
                  <div
                    className={`pipeline-line deal-pipeline-line lead-pipeline-line ${
                      step.completed ? "completed" : ""
                    }`}
                    style={{
                      "--pipeline-color": color,
                      "--deal-pipeline-color": color,
                      "--lead-pipeline-color": color,
                    }}
                  />
                )}
              </div>

              <span className="pipeline-label deal-pipeline-label lead-pipeline-label">
                {step.stage}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
